import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createProgramComplementaryItem,
  deleteProgramComplementaryItem,
  updateProgramComplementaryItem,
} from '@store/membership/ProgramComplementaryItemReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const ProgramComplementaryItemForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.programComplementaryItem)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            return dispatch(createProgramComplementaryItem(values)).then(() => {
              return true
            })
          },
          update: async (values) => {
            await dispatch(updateProgramComplementaryItem(values))
            return true
          },
          delete: async (values) => {
            return dispatch(deleteProgramComplementaryItem(values)).then(() => {
              return true
            })
          },
        }}
      />
    )
  }
)

ProgramComplementaryItemForm.displayName = 'ProgramComplementaryItemForm'

export default ProgramComplementaryItemForm
